export default "__VITE_PUBLIC_ASSET__0a6fc7a6__"